<template>
  <div>
    <v-layout row>
      <v-flex>
        <h4 class="checkout-h4 confirmation-subtitle">Pague o boleto até o dia {{ postOrder.billet_due }}</h4>
       </v-flex>
        <v-flex shrink>
        <v-layout row><v-icon class="alert-card__icon mr-2" color="atention">error_outline</v-icon> <h4 class="atention--text checkout-h4 mt-1">Pagamento Pendente</h4></v-layout>
      </v-flex>
    </v-layout>
      <p class="grey--text">
        Até 3 dias úteis para confirmação do pagamento
      </p>

    <div v-if="isSmAndDown">
      <p id="billetcode" class="billet-box js-emaillink">{{ postOrder.billet_barcode }}</p>
      <div class="btn-next-step">
        <v-btn
          block
          round
          depressed
          class="normal-text"
          color="primary"
          dark
          @click.native="copyCode"
        >{{ copyBtn }}</v-btn>
      </div>
      <div class="btn-next-step">
        <v-btn
          block
          round
          depressed
          class="normal-text"
          color="primary"
          dark
          outline
          @click="openTicket"
        >Ver boleto</v-btn>
      </div>
    </div>
    <div v-if="!isSmAndDown">
      <v-layout row>
        <v-flex xs8>
          <p id="billetcode" class="billet-box js-emaillink">{{ postOrder.billet_barcode }}</p>
        </v-flex>
        <v-flex>
          <div class="btn-next-step">
            <v-btn
              round
              depressed
              class="normal-text mr-1"
              color="primary"
              dark
              @click.native="copyCode"
            >{{ copyBtn }}</v-btn>
          </div>
        </v-flex>
        <v-flex>
          <div class="btn-next-step">
            <v-btn
              round
              depressed
              class="normal-text ml-0 mr-0"
              color="primary"
              dark
              outline
              @click="openTicket"
            >Ver boleto</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  created() {
    this.copyBtn = 'Copiar';
  },
  data() {
    return {
      copyBtn: 'Copiar',
    };
  },
  computed: {
    ...mapGetters(['postOrder']),
  },
  methods: {
    copyCode() {
      const selection = window.getSelection();
      const emailLink = document.querySelector('.js-emaillink');

      selection.removeAllRanges();
      const range = document.createRange();
      range.selectNode(emailLink);
      selection.addRange(range);

      try {
        document.execCommand('copy');
        this.copyBtn = 'Copiado';
        this.$toasted.show('Copiado!', {
          theme: 'outline',
          position: 'top-center',
          className: 'bt-toast',
          duration: 3000,
        });
      } catch (err) {
        this.$toasted.show('Erro ao copiar código de barras', {
          theme: 'outline',
          position: 'top-center',
          className: 'bt-toast',
          duration: 3000,
        });
      }

      selection.removeAllRanges();
    },
    openTicket() {
      window.open(this.postOrder.billet_url);
    },
  },
};
</script>

<style scoped>
.bt-toast {
  background-color: #d33724;
}
.billet-box {
  background: #E3EEF9;
  border-radius: 8px;
  padding: 12px;
}
</style>
